import { getRandomId } from "../util/utils";

export class Photo {
	constructor(data) {
		this.id = getRandomId();
		Object.assign(this, data);
	}
}